import { useQuery } from 'react-query'
import { isTreatmentCancellable } from 'src/services/api/treatment'

export const useIsTreatmentCancellable = (appointmentBundleReferenceId: string) => {
  return useQuery(['isTreatmentCancellable', appointmentBundleReferenceId], () =>
    isTreatmentCancellable(appointmentBundleReferenceId)
  )
}
